<template>
  <div class="date" :class="{ active }">{{ date_text }}</div>
</template>
<script>
export default {
  props: {
    start_date: String,
    end_date: String,
    activeIndex: Number
  },
  data() {
    return {
      active: false,
      date_text: ""
    };
  },
  mounted() {
    this.date_text = `${this.start_date} - ${this.end_date}`;
    if (this.activeIndex && this.activeIndex != 1) {
      return;
    }
    this.getDay();
  },
  methods: {
    getDay() {
      const targetDate = new Date(this.end_date);
      const currentDate = new Date();
      const timeDiff = targetDate.getTime() - currentDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (daysDiff <= 3) {
        this.active = true;
        if (daysDiff === 0) {
          this.date_text = "今天到期";
          return;
        }
        this.date_text = `${daysDiff}天后到期`;
      }
    }
  }
};
</script>
<style scoped lang="less">
.date {
  margin-top: 4px;
}
.active {
  color: #ff482c;
}
</style>



// WEBPACK FOOTER //
// src/components/coupon-list/c_date.vue